import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Rx';

import { plainToClass } from 'class-transformer';

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { OrganisationDetails } from 'app/shared/models/org-details.model';

import { SystemDivision } from './systemdivision/system-division.model';
import { OnBoardResponseModel } from './onboard-response.model';
import { OnBoardRequestModel } from './onboard-request.model';

/**
 * Service to fetch Organisation (Client) related information.
 */
@Injectable()
export class ClientHeaderService {
    private orgDetails: Subject<OrganisationDetails>;

    constructor(
        private requestService: ObservableRequestService,
        private cookieService: CookieService) {
        this.orgDetails = new Subject<OrganisationDetails>();
    }

    // @todo improve naming of function
    organisationDetails(orgDetails: OrganisationDetails): void {
        this.orgDetails.next(orgDetails);
    }

    // @todo improve naming of function
    onOrganisationDetailsEvent(): Observable<any> {
        return this.orgDetails.asObservable();
    }

    saveOrgClientDetails(body: Object, orgClientId: number, isClient: boolean): Observable<any> {
        const saveOrgClientDetails =
          `${(isClient ? ConstantsService.CLIENTS_ENDPOINT : ConstantsService.ORGANISATION_ENDPOINT)}/${orgClientId}`;

        return this.requestService
            .putRequest(saveOrgClientDetails,
            JSON.stringify(body),
            this.requestService.getJSONContentType());
    };

    updateReviewDate(body: Object): Observable<any> {
        return this.requestService.postRequest(
            ConstantsService.UPDATE_REVIEW_DATE,
            this.requestService.serialize(body),
            this.requestService.getFormEncodedContentType());
    };

    offboardClient(body: Object): Observable<any> {
        return this.requestService.postRequest(
            ConstantsService.OFFBOARD_CLIENT,
            this.requestService.serialize(body),
            this.requestService.getFormEncodedContentType());
    };

    listSystemDivisions(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.LIST_SYSTEM_DIVISIONS)
            .map(response => {
                return plainToClass(SystemDivision, response.arrResult as Object[]);
            });
    }

    selectSystemDivision(body): Observable<any> {
        return this.requestService.postRequest(
            ConstantsService.SET_SYSTEM_DIVSION,
            this.requestService.serialize(body),
            this.requestService.getFormEncodedContentType());
    }

    getOrganisationDetails(orgId: number): Observable<any> {
        const userId = this.cookieService.get(ConstantsService.COOKIE_LOGIN_USER_NAME);
        const orgDetailsURI =
            ConstantsService.ORGANISATION_DETAILS + '/' + orgId + '/' + userId;
        return this.requestService.getRequest(orgDetailsURI)
            .map(response => {
                return plainToClass(OrganisationDetails, response.arrResult as Object[]);
            });
    }

    updateOnboardClient(onBoardWttData: OnBoardRequestModel): Observable<any> {
        const onboardURL = ConstantsService.ONBOARD_ORG_URL;
        return this.requestService.putRequest(onboardURL,
            JSON.stringify(onBoardWttData),
            this.requestService.getJSONContentType())
            .map(response => {
                return plainToClass(OnBoardResponseModel, response.arrResult as Object);
            });
    }

    initiateComplianceWorkflow(body: Object): Observable<any> {
      return this.requestService.postRequest(
        ConstantsService.COMPLIANCE_CHECK,
        this.requestService.serialize(body),
        this.requestService.getFormEncodedContentType());
    }

  initiateClientReview(body: Object): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.CLIENT_REVIEW,
      this.requestService.serialize(body),
      this.requestService.getFormEncodedContentType());
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/client-header.service.ts